import React, { useState } from 'react';
import { Box, Button, Chip, TextField, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SectionHeader from './SectionHeader';
import { REFINE_CHIPS } from './constants';

const OpenDoorIntroductionSection = () => {
  const [refineText, setRefineText] = useState('');

  return (
    <Box
      border={1}
      borderColor='divider'
      borderRadius={2}
      p={2.5}
      display='flex'
      flexDirection='column'
      minHeight={{ md: 640 }}
      sx={{ opacity: 0.85 }}
    >
      <SectionHeader
        number={2}
        title='Review your suggested introduction'
        endAdornment={
          <Chip
            size='small'
            label='AI generated'
            sx={{
              height: 22,
              fontSize: 11,
              fontWeight: 600,
              bgcolor: '#e3f2fd',
              color: 'primary.main',
            }}
          />
        }
      />

      <Box
        display='grid'
        gridTemplateColumns={{ xs: '1fr', sm: '1.4fr 1fr' }}
        gap={1.5}
        flex={1}
        mb={2}
      >
        <Box
          border={1}
          borderColor='divider'
          borderRadius={1.5}
          bgcolor='#fff'
          p={2}
          display='flex'
          flexDirection='column'
          minHeight={180}
        >
          <Box display='flex' alignItems='center' justifyContent='space-between' mb={1.5}>
            <Typography variant='body2' fontWeight={700}>
              Suggested Introduction
            </Typography>
            <Button
              size='small'
              disabled
              startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />}
              sx={{ textTransform: 'none', fontWeight: 600, minWidth: 0 }}
            >
              Copy
            </Button>
          </Box>
          <Typography variant='body2' color='text.secondary' sx={{ fontStyle: 'italic', lineHeight: 1.6 }}>
            Under construction.
          </Typography>
        </Box>

        <Box border={1} borderColor='divider' borderRadius={1.5} bgcolor='#fff' p={2} minHeight={180}>
          <Typography variant='body2' fontWeight={700} mb={1.5}>
            Version history
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{ fontStyle: 'italic' }}>
            Under construction.
          </Typography>
        </Box>
      </Box>

      <Box mt='auto' bgcolor='#fff' p={2} borderRadius={1.5} border={1} borderColor='divider'>
        <Typography variant='body2' fontWeight={700} mb={1}>
          Refine this introduction
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={2}
          value={refineText}
          onChange={(event) => setRefineText(event.target.value)}
          placeholder="Tell me what you'd like me to improve…"
          sx={{
            mb: 1,
            '& .MuiOutlinedInput-root': { bgcolor: '#fff', borderRadius: 1.5 },
          }}
        />
        <Box display='flex' flexWrap='wrap' gap={0.75} mb={1.5}>
          {REFINE_CHIPS.map((chip) => (
            <Chip
              key={chip}
              label={chip}
              size='small'
              variant='outlined'
              clickable
              onClick={() => setRefineText(chip)}
              sx={{
                borderRadius: 5,
                fontWeight: 500,
                bgcolor: refineText === chip ? '#e3f2fd' : undefined,
                borderColor: refineText === chip ? 'primary.main' : 'divider',
                color: refineText === chip ? 'primary.main' : 'text.primary',
                '&:hover': {
                  bgcolor: '#e3f2fd',
                  borderColor: 'primary.main',
                },
              }}
            />
          ))}
        </Box>
        <Box display='flex' justifyContent='flex-end'>
          <Button
            variant='contained'
            color='primary'
            disabled
            startIcon={<AutoAwesomeIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 1.5,
            }}
          >
            Rewrite
          </Button>
        </Box>
        <Box display='flex' alignItems='flex-start' gap={0.75} mt={1.5}>
          <InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', mt: 0.15 }} />
          <Typography variant='caption' color='text.secondary'>
            Tip: Each rewrite creates a new version. All versions are saved in this session.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OpenDoorIntroductionSection;
